import { Button } from "@/components/ui/button";
import { KEYS } from "@/lib/tourHelper";
import { AnswerSubCategoryDetail } from "@/schema/app/assessment/answerSubCategoryDetail";
import { useController, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface ActionButtonsProps {
  actions: {
    saveDraft: () => Promise<boolean>;
    markCompleted: () => Promise<boolean>;
    isSaving: boolean;
    isMarking: boolean;
  };
}

function ActionButtons({ actions }: ActionButtonsProps) {
  const { t } = useTranslation();
  const {
    formState: { isDirty },
    control,
  } = useFormContext<AnswerSubCategoryDetail>();

  const {
    field: { value: isSubmitted },
  } = useController({
    control,
    name: "is_submitted",
  });

  return (
    <div className="flex gap-4">
      <Button
        data-tour={KEYS.SUB_CATEGORY.MARK_AS_COMPLETE_BUTTON}
        disabled={isSubmitted}
        isLoading={actions.isMarking || actions.isSaving}
        onClick={actions.markCompleted}
      >
        {t("mark-as-completed")}
      </Button>
      <Button
        data-tour={KEYS.SUB_CATEGORY.SAVE_DRAFT_BUTTON}
        isLoading={actions.isSaving || actions.isMarking}
        variant="secondary"
        onClick={actions.saveDraft}
        disabled={!isDirty || isSubmitted}
      >
        {t("save-draft")}
      </Button>
    </div>
  );
}

export default ActionButtons;
